/* eslint-disable */
/* @flow */


import React, { Component } from 'react';
import { View, Text, StyleSheet ,Image} from 'react-native';

import Cell from './Cell'
import ProfilePhoto from './ProfilePhoto'

import styles from './Styles/ProfilePhotoCellStyles'


// create a component
class ProfilePhotoCell extends Component {
  render() {
    const { children, theme, path } = this.props
    const source = path && { uri: path }
    return (
      <Cell backgroundColor={'black'} >
      <View style={styles.coverContainer}>
        <Image
          blurRadius={2}
          style={styles.cover}
          resizeMode="cover"
          source={source}
        />
      </View>
      <View style={styles.container}>{children}
      </View>
    </Cell>
    );
  }
}


export default ProfilePhotoCell
